import * as React from 'react';
import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { insertTable as insertTableCmd } from 'roosterjs-editor-api';
import { InsertTablePane } from 'owa-editor-insert-table-pane';

const MAX_TABLE_WIDTH = 10;
const MAX_TABLE_HEIGHT = 10;

const insertTable: RibbonButton = {
    key: 'insertTable',
    title: () => strings.insertTable,
    imageSrc: require('../svg/table.svg'),
    createDropDownCallback: (target, plugin, dismiss, logUsage) => (
        <Callout
            gapSpace={0}
            target={target}
            isBeakVisible={false}
            directionalHint={DirectionalHint.bottomAutoEdge}
            onDismiss={dismiss}>
            <InsertTablePane
                editor={plugin.getEditor()}
                onInsertTable={(cols, rows) => insertTableCmd(plugin.getEditor(), cols, rows)}
                maxNumCols={MAX_TABLE_HEIGHT}
                maxNumRows={MAX_TABLE_WIDTH}
            />
        </Callout>
    ),
};

export default insertTable;
